import React from "react";
import IndustriesImg from "../../assets/img/industries/IndustriesImg.webp";
import IndustriesTopWave from "../../assets/img/industries/IndustriesTopWave.webp";
import IndustriesBottomWave from "../../assets/img/industries/IndustriesBottomWave.webp";

import {
  IndustriesCircleIcon,
  IndustriesJobIcon,
  IndustriesScaleIcon,
} from "../common/Icons";

const Industries = () => {
  return (
    <>
      <div
        className="w-100 open_overlay_sections_none FromTopWave"
        id="industries"
      >
        <img className="w-100" src={IndustriesTopWave} alt="" />
      </div>
      <section className=" open_overlay_sections_none bg_pink pt-4 pt-sm-2 margin-top-minus-industries ">
        <div className="container">
          <div className="text-center mb-4 mb-lg-5 py-lg-0 py-5">
            <h2 className="d-inline main_heading px-3 py-2 bg_red mb-0">
              Industries
            </h2>
          </div>
          <div className="row justify-content-center justify-content-lg-between align-items-center">
            <div
              className="col-lg-5 mb-4 mb-lg-0 order-lg-1 order-2"
              data-aos="fade-up-right"
              data-aos-duration="1500"
            >
              <div className="mt-sm-0 mt-4 moving_animation_img py-lg-0 pt-5">
                <img className="w-100" src={IndustriesImg} alt="" />
              </div>
            </div>
            <div
              className="col-lg-6 mt-sm-0 order-lg-2 order-1"
              data-aos="fade-up-left"
              data-aos-duration="1500"
            >
              <div>
                <div className="d-flex mb-2 card_shadow p-3">
                  <div>
                    <span>
                      <IndustriesJobIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Cursus eu netus sem auctor feugiat .
                    </h2>
                    <p className="main_para mb-0">
                      Nunc malesuada eget diam id sit elit, platea. Purus
                      fermentum, porta porta sollicitudin mi convallis. Congue
                      donec arcu volutpat Pulvinar.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-2 card_shadow p-3">
                  <div>
                    <span>
                      <IndustriesScaleIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Elementum ac, ullamcorper sagittis.
                    </h2>
                    <p className="main_para mb-0">
                      Felis massa morbi ornare vitae, etiam mauris. Sollicitudin
                      tortor auctor scelerisque commodo varius. Ut ante amet
                      eget tellus cras curabitur.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 card_shadow p-3">
                  <div>
                    <span>
                      <IndustriesCircleIcon />
                      {/* <img className="me-4 me-lg-5" src={EratIcon} alt="" /> */}
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Erat tellus nec, odio congue.
                    </h2>
                    <p className="main_para mb-0">
                      Quam ac enim egestas diam blandit eu. Velit nisi in tempus
                      tempor. Est, velit integer quis eu, viverra ultricies
                      nullam Tortor sapien.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className=" open_overlay_sections_none w-100 FromBottomWave">
        <img className="w-100" src={IndustriesBottomWave} alt="" />
      </div>
    </>
  );
};

export default Industries;
